import React, { useEffect, useState } from "react";

const API_KEY = "e73f38ed07df3ee7d403291026d20fd0";
const ODDS_API_URL = "https://api.the-odds-api.com/v4/sports";

const leagues = [
  { key: "basketball_nba", name: "NBA" },
  { key: "baseball_mlb", name: "MLB" },
  { key: "americanfootball_nfl", name: "NFL" },
];

const OddsList = () => {
  const [selectedLeague, setSelectedLeague] = useState(leagues[0].key);
  const [odds, setOdds] = useState([]);

  useEffect(() => {
    const fetchOdds = async () => {
      try {
        const response = await fetch(
          `${ODDS_API_URL}/${selectedLeague}/odds?regions=us&apiKey=${API_KEY}`
        );
        const data = await response.json();
        setOdds(data);
      } catch (error) {
        console.error("Error fetching odds:", error);
      }
    };
    
    fetchOdds();
  }, [selectedLeague]);

  return (
    <div>
      <h2>Betting Odds</h2>
      <label>League: </label>
      <select onChange={(e) => setSelectedLeague(e.target.value)} value={selectedLeague}>
        {leagues.map((league) => (
          <option key={league.key} value={league.key}>{league.name}</option>
        ))}
      </select>
      <ul>
        {odds.length > 0 ? (
          odds.map((game) => (
            <li key={game.id}>
              {game.home_team} vs {game.away_team} - Odds: {game.bookmakers[0]?.markets[0]?.outcomes.map(outcome => `${outcome.name}: ${outcome.price}`).join(" | ")}
            </li>
          ))
        ) : (
          <p>No odds available</p>
        )}
      </ul>
    </div>
  );
};

export default OddsList;
